export enum FileStatus {
  completed = 'completed',
  paused = 'paused',
  stopped = 'stopped',
  aborted = 'aborted',
  errored = 'errored',
  progressing = 'progressing',
  preparing = 'preparing',
}
